module.exports = __webpack_public_path__ + "static/media/rankBadgeYellow.341cdf9b.svg";